import dayjs from 'dayjs'
import { CompetitionFormValues } from './types'

export const RIDS_ALLOW_PROMOTION = ['anipet']

export const MAX_RANGE_DAYS = 366

const RANK_BY_TYPES = {
  0: 'value',
  1: 'target',
}

const COMPETITION_TYPE_TYPES = {
  0: 'qty',
  1: 'income',
  2: 'percentage_income',
  3: 'percentage_qty',
  4: 'weight',
}

const DEFAULT_CAMPAIGN_TYPE = 1
const DEFAULT_PARAMETER = 'competition'

const RANK_BY_MENU_ITEMS = Object.entries(RANK_BY_TYPES).map(([id, name]) => ({ id, name }))

const COMPETITION_TYPE_MENU_ITEMS = Object.entries(COMPETITION_TYPE_TYPES).map(([id, name]) => ({ id, name }))

const ITEM_TYPE_MENU_ITEMS = [
  { id: 'product_id', name: 'product_id' },
  { id: 'model_id', name: 'model_id' },
  { id: 'sub_model_id', name: 'sub_model_id' },
  { id: 'segment', name: 'segment' },
  { id: 'segment2', name: 'segment2' },
  { id: 'category', name: 'category' },
  { id: 'category2', name: 'category2' },
  { id: 'promotion', name: 'promotion' },
  { id: 'brand', name: 'brand' },
]

enum CAMPAIGN_STATUS_TYPES {
  DELETED = -1,
  ACTIVE = 0,
  DEACTIVE = 1,
}

export {
  RANK_BY_TYPES,
  COMPETITION_TYPE_TYPES,
  DEFAULT_CAMPAIGN_TYPE,
  DEFAULT_PARAMETER,
  RANK_BY_MENU_ITEMS,
  COMPETITION_TYPE_MENU_ITEMS,
  ITEM_TYPE_MENU_ITEMS,
  CAMPAIGN_STATUS_TYPES,
}

// Фабрика правил для одного поля
export const dateValidationRules = (
  label: string,
  dependencies: Partial<
    Record<keyof CompetitionFormValues['products_cluster_data'], { after?: string; before?: string }>
  >
) => {
  return {
    required: `${label} is required`,
    validate: {
      after: (value: string, allValues: CompetitionFormValues) => {
        if (!value) return true
        const dep = Object.values(dependencies)[0]
        if (dep?.after) {
          const afterValue = (allValues.products_cluster_data as any)[dep.after]
          if (afterValue && dayjs(value).isBefore(dayjs(afterValue))) {
            return `${label} must be after or equal to ${dep.after}`
          }
        }
        return true
      },
      before: (value: string, allValues: CompetitionFormValues) => {
        if (!value) return true
        const dep = Object.values(dependencies)[0]
        if (dep?.before) {
          const beforeValue = (allValues.products_cluster_data as any)[dep.before]
          if (beforeValue && dayjs(value).isAfter(dayjs(beforeValue))) {
            return `${label} must be before or equal to ${dep.before}`
          }
        }
        return true
      },
    },
  }
}

const LRM = '\u200E'
const RLM = '\u200F'

export const wrapBidi = (text: string) => {
  return text
    .split(/(\s+)/)
    .map((token) => {
      if (/^[0-9_]+$/.test(token)) {
        return `${LRM}${token}${LRM}`
      } else if (/^[\u0590-\u05FF]+$/.test(token)) {
        return `${RLM}${token}${RLM}`
      }
      return token
    })
    .join('')
}

export const stripBidi = (t: string) => t.replace(/[\u200E\u200F]/g, '')
